import { useSelector } from '@redux';
import { Card, Form } from 'antd';
import FormSelect from 'components/form/FormSelect';
import { RETURN_CHANNEL } from 'constants/ordersReturn';
import { useTranslation } from 'react-i18next';
import { DynamicObjectType } from 'types/commons';

export default function ToWarehouse() {
  const { t } = useTranslation();

  const user = useSelector<DynamicObjectType>((state) => state.auth.data);

  return (
    <Form.Item
      noStyle
      shouldUpdate={(prevValues, curValues) =>
        prevValues.returnType !== curValues.returnType
      }
    >
      {({ getFieldValue }) => {
        const returnType = getFieldValue('returnType');
        if (returnType === RETURN_CHANNEL['OFFLINE'].value)
          return (
            <Card title={t('ordersReturn.toWarehouse')}>
              <FormSelect
                reference={{
                  labelProp: 'name',
                  model: `locations`,
                  searchMoreKeys: ['name', 'code'],
                  valueProp: 'id',
                  allowClear: true,
                  labelFormat: (item) => (
                    <div>
                      {item?.name
                        ? `${item?.name} | ${item?.code}`
                        : item?.code}
                    </div>
                  ),
                  operator: 'contL',
                  initFilters: {
                    filters: [
                      {
                        condition: 'and',
                        key: 'id',
                        operator: 'in',
                        value: user?.locationCode?.split(',') || [],
                      },
                      {
                        condition: 'and',
                        key: 'isStore',
                        operator: 'eq',
                        value: 'true',
                      },
                    ],
                  },
                }}
                name="returnWarehouseId"
                rules={[
                  { required: true, message: 'Please enter To Warehouse' },
                ]}
                placeholder="Select"
              />
            </Card>
          );
        return <></>;
      }}
    </Form.Item>
  );
}
